// extracted by mini-css-extract-plugin
module.exports = {"ApplyConstract":"index-module_ApplyConstract_w2CZi","content":"index-module_content_RcmFO","title":"index-module_title_3FCwk","paragraph":"index-module_paragraph_DhlQI"};